import { render } from "./ViewBatchToApproveContainer.vue?vue&type=template&id=db943eca"
import script from "./ViewBatchToApproveContainer.vue?vue&type=script&lang=js"
export * from "./ViewBatchToApproveContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__